import { DOMAttributes, forwardRef, PropsWithChildren } from 'react'
import Styles from 'components/DocRightRail/screens/AIAssistant/Card.module.scss'
import cx from 'classnames'

interface Props extends DOMAttributes<HTMLDivElement> {
  className?: string
}

export const Content = ({ children, withIcon = false }: PropsWithChildren<{ withIcon?: boolean }>) => (
  <div className={cx(Styles.content, { [Styles.withIcon]: withIcon })}>{children}</div>
)

export const Card = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(({ children, className, ...props }, fRef) => (
  <div className={cx(Styles.card, className)} {...props} ref={fRef}>
    {children}
  </div>
))
